import { WidgetTableColumn, WidgetTableColumnsData } from 'jamespot-user-api';

export function labelize(name: string, tableColumnsData: WidgetTableColumnsData, initialValue: string) {
    const colData = tableColumnsData.find((el) => el.name === name);
    if (colData && colData.label && colData.label !== '') {
        return colData.label;
    }

    return initialValue;
}

export function updateTableColumns(columns: WidgetTableColumn[], headers: string[]) {
    const spliceIdx: { index: number; name: string }[] = [];
    const tmpColumns = [...columns];
    headers.forEach((name, index) => {
        const item = tmpColumns.find((el) => el.name === name);
        if (item === undefined) {
            spliceIdx.push({ index, name });
        }
    });

    spliceIdx.forEach((el) => {
        tmpColumns.splice(el.index, 0, {
            name: el.name,
            label: el.name,
            widget: [],
            type: 'text',
            sortable: true,
        });
    });

    return tmpColumns.filter((el) => headers.includes(el.name));
}
